export interface IframeCreationRequest {
    ngpgHost: string;
    themeName: string;
    usecase: CardSubmitUseCase;
    styleProperties: {
        [key: string]: string | number | boolean;
    };
}

export interface IframeCreationResponse {
    success: boolean;
    errorMessage: string;
}

export enum CardSubmitUseCase {
    register_card = 'register_card',
    update_cvv = 'update_cvv',
    update_expiry = 'update_expiry',
}

export enum IframeUrls {
    register_card = '/cardIframe/card.html',
    update_cvv = '/cardIframe/cvv.html',
    update_expiry = '/cardIframe/expiry.html',
}

export interface CardSubmitRequest {
    usecase: CardSubmitUseCase;
    submitUrl: string;
    jwtToken: string;
}

export interface ErrorResponse {
    errorCode: number;
    errorMessage: string;
    errorDescription: string;
}

export interface CardInputRequest {
    usecase: CardSubmitUseCase;
    paymentMethod: string;
    validationMessages: { [InputType: string]: { [key: string]: string } };
    inputProperties: { [InputType: string]: { [key: string]: string | number | RegExp | boolean } };
    binCheckDetails?: { [key: string]: string };
    additionalData?: { [key: string]: string };
    iframeSource: string;
}

export enum InputType {
    card_number = 'card_number',
    card_holder_name = 'card_holder_name',
    card_expiry = 'card_expiry',
    card_cvv = 'card_cvv',
}

export interface CardFormErrorRequest {
    inputType: InputType;
    level: 'error' | 'warning' | 'info';
    validationMessage: string;
}

export type CustomType =
    | string
    | { [key: string]: unknown }
    | CardSubmitRequest
    | CardInputRequest
    | ErrorResponse
    | CardFormErrorRequest
    | CardFormInputValue
    | GTMEventRequest
    | undefined;

export interface CardFormInputValue {
    inputType: InputType;
    value: string;
}

export interface GTMEventRequest {
    inputType: InputType;
    value: string;
    isValid: boolean;
    eventType: string;
}
